const mutations = {
  SET_DYNAMIC_CONTENTS (state, { dynamic_contents }) {
    state.dynamic_contents = dynamic_contents
  }
}

export default mutations
